import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

import Home from "./pages/Home";
import Episodes from "./pages/Episodes";
import EpisodeDetail from "./pages/EpisodeDetail";
import Guests from "./pages/Guests";
import About from "./pages/About";
import Apply from "./pages/Apply";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import Programs from "./pages/Programs";
import Team from "./pages/Team";
import TeamMember from "./pages/TeamMember";
import Meeting from "./pages/Meeting";
import Donate from "./pages/Donate";
import PiecesOfHope from "./pages/programs/PiecesOfHope";
import PurposeInTheProcess from "./pages/programs/PurposeInTheProcess";
import HavenOfHope from "./pages/programs/HavenOfHope";
import GokSecondChance from "./pages/programs/GokSecondChance";

function Shell({ children }) {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith("/admin");
    return (
        <>
            {!isAdmin && <Header />}
            <main className={isAdmin ? "" : "min-h-[60vh]"}>{children}</main>
            {!isAdmin && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <CartProvider>
                        <Shell>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/episodes" element={<Episodes />} />
                                <Route path="/episodes/:id" element={<EpisodeDetail />} />
                                <Route path="/guests" element={<Guests />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/apply" element={<Apply />} />
                                <Route path="/programs" element={<Programs />} />
                                <Route path="/programs/pieces-of-hope" element={<PiecesOfHope />} />
                                <Route path="/programs/purpose-in-the-process" element={<PurposeInTheProcess />} />
                                <Route path="/programs/haven-of-hope" element={<HavenOfHope />} />
                                <Route path="/programs/gok-second-chance" element={<GokSecondChance />} />
                                <Route path="/team" element={<Team />} />
                                <Route path="/team/:slug" element={<TeamMember />} />
                                <Route path="/meeting" element={<Meeting />} />
                                <Route path="/donate" element={<Donate />} />
                                <Route path="/shop" element={<Shop />} />
                                <Route path="/shop/:id" element={<ProductDetail />} />
                                <Route path="/cart" element={<Cart />} />
                                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                                <Route path="/admin/login" element={<Login />} />
                                <Route path="/admin" element={<AdminDashboard />} />
                            </Routes>
                        </Shell>
                        <Toaster position="top-center" richColors />
                    </CartProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
